/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePrivateCampaignDto
 */
export interface CreatePrivateCampaignDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePrivateCampaignDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrivateCampaignDto
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePrivateCampaignDto
     */
    ownerId: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePrivateCampaignDto
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePrivateCampaignDto
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePrivateCampaignDto
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePrivateCampaignDto
     */
    state?: string | null;
}

/**
 * Check if a given object implements the CreatePrivateCampaignDto interface.
 */
export function instanceOfCreatePrivateCampaignDto(value: object): value is CreatePrivateCampaignDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function CreatePrivateCampaignDtoFromJSON(json: any): CreatePrivateCampaignDto {
    return CreatePrivateCampaignDtoFromJSONTyped(json, false);
}

export function CreatePrivateCampaignDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePrivateCampaignDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'ownerId': json['owner_id'],
        'companyId': json['company_id'],
        'startDate': json['start_date'] == null ? undefined : json['start_date'],
        'endDate': json['end_date'] == null ? undefined : json['end_date'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function CreatePrivateCampaignDtoToJSON(json: any): CreatePrivateCampaignDto {
    return CreatePrivateCampaignDtoToJSONTyped(json, false);
}

export function CreatePrivateCampaignDtoToJSONTyped(value?: CreatePrivateCampaignDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'owner_id': value['ownerId'],
        'company_id': value['companyId'],
        'start_date': value['startDate'],
        'end_date': value['endDate'],
        'state': value['state'],
    };
}

